<div
	class="z-30 absolute top-4 cursor-pointer p-2 duration-300"
	(click)="toggleSideNav()"
	[ngClass]="{
		'-right-6': sideNavCollapsed || !sideNavCompact,
		'opacity-0 pointer-events-none -right-48':
			!sideNavCollapsed && sideNavCompact,
	}"
	data-intercom-target="side-nav-collapse-intercom"
	[testHook]="testHooks.ToggleSideNavDiv"
>
	<div
		class="bg-white rounded-md h-6 w-6 flex items-center justify-center shadow-md mr-1 duration-300 hover:bg-grey-veryLight"
	>
		<app-icon
			[icon]="ICON.RIGHT"
			class="m-0 p-0 text-xs duration-300"
			[class.rotate-180]="!sideNavCollapsed"
			[testHook]="testHooks.RightIcon"
		/>
	</div>
</div>

<div
	class="flex flex-col py-4 pl-2 pr-1 duration-300 h-[calc(100vh-110px)] z-20 overflow-hidden hover:overflow-y-auto sideNavContainer"
	[ngClass]="{
		'w-14 absolute': sideNavCollapsed,
		'w-72 relative': !sideNavCollapsed,
	}"
	[class.overflow-y-auto]="sideNavCompact && !sideNavCollapsed"
	(mouseenter)="sideNavHoverEnter()"
	(mouseleave)="sideNavHoverLeave()"
	style="scrollbar-gutter: stable; grid-area: sidenav"
>
	<div
		class="h-6 flex-shrink-0 relative flex whitespace-nowrap mb-2 cursor-pointer"
		(click)="toggleAllSelectedGroups()"
		data-intercom-target="side-nav-collapse-all-intercom"
		[testHook]="testHooks.ToggleAllSelectedGroupsDiv"
	>
		<div class="mr-2">
			<app-icon
				[icon]="ICON.DOUBLE_UP"
				[class.rotate-180]="!allGroupsExpanded"
				class="m-0 p-0 duration-300 size-sm"
				[testHook]="testHooks.DoubleUpIcon"
			></app-icon>
		</div>
		<div [class.opacity-0]="sideNavCollapsed" class="duration-300">
			<span *ngIf="allGroupsExpanded">Collapse all</span>
			<span *ngIf="!allGroupsExpanded">Expand all</span>
		</div>
	</div>

	<div class="relative mb-2 min-w-[200px]">
		<app-icon
			[icon]="ICON.SEARCH"
			class="duration-300 top-2.5 absolute z-10 pointer-events-none"
			[ngClass]="{
				'opacity-0 left-3.5': !sideNavCollapsed,
				'left-1': sideNavCollapsed,
			}"
			[testHook]="testHooks.SearchIcon"
		></app-icon>
		<app-matter-search
			class="mb-2 duration-300 relative"
			[ngClass]="{
				'opacity-0 -left-2': sideNavCollapsed,
				'left-0': !sideNavCollapsed,
			}"
		></app-matter-search>
	</div>

	<div *ngIf="showBackButton">
		<button
			class="sidenav-link"
			(click)="goToPreviousPage()"
			[testHook]="testHooks.GoToPreviousPageButton"
		>
			<app-icon
				[icon]="ICON.BACK"
				class="mr-2"
				[testHook]="testHooks.BackIcon"
			></app-icon>
			<span *ngIf="!sideNavCollapsed">{{ backString | capitalize }}</span>
		</button>
	</div>

	<div class="mb-8">
		<ng-container
			*ngFor="let menuLink of menuLinks$ | async; trackBy: trackGroup"
		>
			<a
				*ngIf="menuLink.url && menuLink.show"
				[routerLink]="menuLink.url"
				class="flex items-center sidenav-link"
				[routerLinkActive]="[isActiveClass]"
				[routerLinkActiveOptions]="{ matrixParams: 'subset', exact: false }"
				[attr.data-intercom-target]="'matter-' + menuLink.label"
				[testHook]="testHooks.Link"
			>
				<app-icon
					class="dropdown-icon"
					[icon]="menuLink.icon"
					[testHook]="testHooks.Icon"
				></app-icon>
				<span class="duration-300" [class.opacity-0]="sideNavCollapsed">{{
					menuLink.label
				}}</span>
			</a>
			<div
				*ngIf="!menuLink.url && menuLink.show"
				class="sidenav__item-container"
			>
				<button
					class="flex justify-between sidenav-link"
					[class.selected]="menuLink.selected && !selectedGroups[menuLink.id]"
					(click)="toggleSelectedGroup(menuLink.id)"
					[intercomAttr]="'matter-' + menuLink.label"
					[testHook]="testHooks.ToggleSelectedGroupButton"
				>
					<div class="flex w-full">
						<app-icon
							class="dropdown-icon"
							[icon]="menuLink.icon"
							[testHook]="testHooks.Icon1"
						></app-icon>
						<span class="duration-300" [class.opacity-0]="sideNavCollapsed">{{
							menuLink.label
						}}</span>
					</div>
					<app-icon
						*ngIf="!sideNavCollapsed"
						[icon]="ICON.DOWN"
						class="text-sm !p-0 !m-0 duration-300"
						[class.rotate-180]="selectedGroups[menuLink.id]"
						[testHook]="testHooks.DownIcon"
					></app-icon>
				</button>
				<div
					[@openClose]
					*ngIf="selectedGroups[menuLink.id]"
					class="flex flex-col overflow-hidden ml-3 px-1 border-l menu-links"
				>
					<ng-container *ngFor="let link of menuLink.links">
						<a
							*ngIf="link.show"
							class="sidenav-link mt-1"
							[routerLink]="link.url"
							[routerLinkActive]="[isActiveClass]"
							[routerLinkActiveOptions]="{ matrixParams: 'subset' }"
							[attr.data-intercom-target]="'matter-' + link.label"
							[testHook]="testHooks.MenuItemLink"
						>
							<span class="duration-300" [class.opacity-0]="sideNavCollapsed">{{
								link.label
							}}</span>
						</a>
					</ng-container>
				</div>
			</div>
		</ng-container>
	</div>
</div>
